module.exports = __webpack_public_path__ + "static/wpack/extracted/pink-hearte4c147c65359c88ba420b6dd8e86c71f.svg";